'use strict';
var addPerfVars, externalObjectLoader, getMultiCookies, onloadScript, perflibLoader;

getMultiCookies = function(re) {
  var i, j, key, len, m, pair, ref, res, val;
  res = [];
  ref = document.cookie.split(/\s*;\s*/);
  for (i = 0, len = ref.length; i < len; i++) {
    pair = ref[i];
    if ((m = pair.match(/^([^=]+)=(.*)/))) {
      j = m.length - 2, key = m[j++], val = m[j++];
      if (re.test(key)) {
        res.push([key, decodeURIComponent(val).replace(/\+/g, ' ')]);
      }
    }
  }
  return res;
};

addPerfVars = function(performance) {
  var pageData, ref, ref1, ref2, ref3, ref4, ref5, xCookies;
  if ((BOOMR.t_header != null) && (((ref = window.performance) != null ? (ref1 = ref.timing) != null ? ref1.requestStart : void 0 : void 0) != null)) {
    BOOMR.addVar('t_header', BOOMR.t_header - window.performance.timing.requestStart);
  }
  if (OptimizeSuite.TrackingHub.page != null) {
    pageData = OptimizeSuite.TrackingHub.page.data();
    BOOMR.addVar("page_channel", (ref2 = pageData.channel) != null ? ref2 : "");
    BOOMR.addVar("page_country", (ref3 = pageData.country) != null ? ref3 : "");
    BOOMR.addVar("page_division", (ref4 = pageData.division) != null ? ref4 : "");
    BOOMR.addVar("page_type", (ref5 = pageData.type) != null ? ref5 : "");
  }
  xCookies = getMultiCookies(/^x-/);
  if (xCookies.length) {
    BOOMR.addVar("x_cookies", xCookies.map(function(arg) {
      var name, val;
      name = arg[0], val = arg[1];
      return name.slice(2) + "=" + val;
    }).join(','));
  }
  return OptimizeSuite.TrackingHub.add("performance", {
    performance: performance
  });
};

onloadScript = function(parent) {
  var defaultConfig, key, timer, w;
  if (parent == null) {
    parent = window.parent;
  }
  w = window;
  if (w !== parent) {
    w = parent;
    window.BOOMR = w.BOOMR;
    window.Groupon = w.Groupon;
    window.OptimizeSuite = w.OptimizeSuite;
    window.applicationConfig = w.applicationConfig;
  }
  defaultConfig = {
    user_ip: BOOMR.utils.getCookie('b'),
    beacon_url: "/analytic/view.gif",
    BW: {
      enabled: false
    },
    DNS: {
      enabled: false
    },
    autorun: false
  };
  if (typeof applicationConfig !== "undefined" && applicationConfig !== null) {
    for (key in applicationConfig) {
      if (applicationConfig[key] != null) {
        defaultConfig[key] = applicationConfig[key];
      }
    }
  }
  BOOMR.init(defaultConfig);
  if (BOOMR.t_lstart != null) {
    BOOMR.addVar("t_lstart", BOOMR.t_lstart);
  }
  for (timer in BOOMR.gtimers) {
    BOOMR.addVar(timer, BOOMR.gtimers[timer]);
  }
  BOOMR.subscribe('before_beacon', addPerfVars);
  BOOMR.t_end = new Date().getTime();
  BOOMR.addVar("t_end", BOOMR.t_end);
  if (BOOMR.t_done != null) {
    BOOMR.plugins.RT.endTimer("t_done", BOOMR.t_done);
    return BOOMR.page_ready();
  }
};

externalObjectLoader = function(url, onLoadHandler, id) {
  var doc, dom, iframe, where;
  if (id == null) {
    id = 'js-iframe-async';
  }
  iframe = document.createElement('iframe');
  iframe.id = 'boomr-frame';
  iframe.src = "javascript:false";
  iframe.setAttribute('aria-hidden', 'true');
  iframe.hidden = "hidden";
  (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; position: absolute';
  iframe.frameBorder = 0;
  where = document.getElementsByTagName('script');
  where = where[where.length - 1];
  where.parentNode.insertBefore(iframe, where);
  try {
    doc = iframe.contentWindow.document;
  } catch (error) {
    dom = document.domain;
    iframe.src = "javascript: var d = document.open();d.domain='" + dom + "';void(0);";
    doc = iframe.contentWindow.document;
  }
  doc.open()._load3po = function() {
    var js, scriptInit;
    if (dom != null) {
      this.domain = dom;
    }
    scriptInit = this.createElement("script");
    scriptInit.type = "text/javascript";
    scriptInit.text = "Groupon = window.parent.Groupon;$ = window.parent.$";
    this.body.appendChild(scriptInit);
    js = this.createElement("script");
    js.type = "text/javascript";
    js.id = id;
    js.src = url;
    if (onLoadHandler != null) {
      js.onload = function() {
        return onLoadHandler();
      };
    }
    return this.body.appendChild(js);
  };
  doc.write('<body onload="document._load3po();">');
  return doc.close();
};

perflibLoader = function() {
  var found, frame, frameId, frames, i, len, ref, url, w;
  w = window;
  if (w !== w.parent) {
    w = window.parent;
  }
  frames = w.frames;
  found = false;
  frameId = 'boomr-if-as';
  for (i = 0, len = frames.length; i < len; i++) {
    frame = frames[i];
    try {
      if ((frame != null ? frame.frames['boomr-if-as'] : void 0) != null) {
        found = true;
        break;
      }
    } catch (error) {

    }
  }
  url = (typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Performance) != null ? ref.boomerangUrl : void 0 : void 0) || '/layout/assets/boomerang-basic-custom-0_9_3.js';
  if (!found) {
    return externalObjectLoader(url, onloadScript, frameId);
  }
};

perflibLoader.getMultiCookies = getMultiCookies;

perflibLoader.addPerfVars = addPerfVars;

perflibLoader.onloadScript = onloadScript;

perflibLoader.externalObjectLoader = externalObjectLoader;

module.exports = perflibLoader;

